import { FileViewer } from "@/components/features/matter/file-repo/FileViewer";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/shadcn/Carousel/Carousel";
import { type MatterFile, type MatterFileReference } from "@/lib/types";
import { cn } from "@/lib/utils/cn";

const carouselControlClassName =
  "z-10 border border-black/10 bg-white/95 text-neutral-900 shadow-md backdrop-blur-sm hover:bg-white hover:text-neutral-900 [&_svg]:text-neutral-900";

export function MedicalRecordPreviewFiles({
  files,
  emptyMessage,
  viewerHeightClassName,
}: {
  files: (MatterFile & {
    fileReferenceId: MatterFileReference["id"];
  })[];
  emptyMessage: string;
  viewerHeightClassName: string;
}) {
  if (files.length === 0) {
    return (
      <div
        className={`border-border text-muted-foreground flex ${viewerHeightClassName} min-h-0 items-center justify-center rounded-md border border-dashed p-8 text-center text-sm`}
      >
        {emptyMessage}
      </div>
    );
  }

  if (files.length === 1) {
    const [file] = files;
    return (
      <FileViewer
        key={file.fileReferenceId}
        fileType="matter-file"
        file={{
          fileName: file.name,
          presignedURLKey: file.presignedUrlKey || "",
        }}
        showTitle
        compactDocxPreview
        wrapperClassName={`${viewerHeightClassName} min-h-0`}
        viewerClassName="min-h-0"
        imageClassName="max-h-full"
      />
    );
  }

  return (
    <div className="flex h-full min-h-0 flex-col gap-3">
      <div className="text-muted-foreground text-xs">
        {files.length} file references
      </div>
      <Carousel className="relative min-h-0 w-full flex-1 [&>div]:h-full">
        <CarouselPrevious
          className={cn(
            "absolute top-1/2 left-4 -translate-y-1/2",
            carouselControlClassName,
          )}
        />
        <CarouselNext
          className={cn(
            "absolute top-1/2 right-4 -translate-y-1/2",
            carouselControlClassName,
          )}
        />
        <CarouselContent className="h-full">
          {files.map((file) => (
            <CarouselItem key={file.fileReferenceId} className="h-full">
              <FileViewer
                fileType="matter-file"
                file={{
                  fileName: file.name,
                  presignedURLKey: file.presignedUrlKey || "",
                }}
                showTitle
                compactDocxPreview
                wrapperClassName={`${viewerHeightClassName} min-h-0`}
                viewerClassName="min-h-0"
                imageClassName="max-h-full"
              />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  );
}
